import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatINR } from "../lib/api";
import { useSEO } from "../lib/seo";

export default function Account() {
  const [form, setForm] = useState({ email: "", phone: "" });
  const [orders, setOrders] = useState(null);
  const [error, setError] = useState("");
  useSEO({ title: "My Orders — Haven Hives", description: "See your Haven Hives order history." });

  const submit = async (e) => {
    e.preventDefault(); setError("");
    try { setOrders(await api.post("/account/orders", form).then((r) => r.data)); }
    catch (err) { setOrders([]); setError(err.response?.data?.detail || "No orders found for those details."); }
  };

  return (
    <div className="max-w-3xl mx-auto px-5 sm:px-8 py-12" data-testid="account-page">
      <h1 className="font-display font-semibold text-3xl sm:text-4xl">My orders</h1>
      <p className="text-charcoal/70 mt-2 text-sm">Checkout is guest-first, so we verify with your email and mobile number — no password to remember.</p>

      <form onSubmit={submit} className="mt-8 bg-white rounded-3xl card-outline p-5 grid sm:grid-cols-2 gap-4">
        <div>
          <label htmlFor="a-email" className="text-xs font-bold uppercase tracking-widest text-charcoal/60">Email used at checkout</label>
          <input id="a-email" type="email" required value={form.email} data-testid="account-email-input"
            onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))} className="mt-1.5 w-full border border-charcoal/15 rounded-2xl px-4 py-3 text-sm" />
        </div>
        <div>
          <label htmlFor="a-phone" className="text-xs font-bold uppercase tracking-widest text-charcoal/60">Mobile number</label>
          <input id="a-phone" inputMode="numeric" required value={form.phone} data-testid="account-phone-input"
            onChange={(e) => setForm((f) => ({ ...f, phone: e.target.value.replace(/\D/g, "").slice(0, 10) }))}
            className="mt-1.5 w-full border border-charcoal/15 rounded-2xl px-4 py-3 text-sm" />
        </div>
        {error && <p role="alert" className="sm:col-span-2 text-sm text-coral font-semibold" data-testid="account-error">{error}</p>}
        <button type="submit" className="sm:col-span-2 bg-forest text-white font-semibold py-3.5 rounded-full" data-testid="account-submit">See my orders</button>
      </form>

      {orders?.length > 0 && (
        <ul className="mt-8 space-y-4" data-testid="account-orders">
          {orders.map((o) => (
            <li key={o.order_number} className="bg-white rounded-3xl card-outline p-5">
              <div className="flex flex-wrap items-center justify-between gap-2">
                <div>
                  <p className="font-display font-semibold text-lg">{o.order_number}</p>
                  <p className="text-xs text-charcoal/60">{new Date(o.created_at).toLocaleDateString("en-IN", { dateStyle: "medium" })} · {o.lines.length} items · {formatINR(o.total)}</p>
                </div>
                <div className="flex items-center gap-3">
                  <span className="sticker bg-sage rounded-full px-3.5 py-1 text-xs font-bold capitalize">{o.status.replace(/_/g, " ")}</span>
                  <Link to={`/track-order?order_number=${o.order_number}`} className="text-sm font-semibold underline underline-offset-4" data-testid={`account-track-${o.order_number}`}>Track</Link>
                </div>
              </div>
              <div className="flex gap-2 mt-3 overflow-x-auto no-scrollbar">
                {o.lines.map((l, i) => <img key={i} src={l.image} alt={l.name} width="48" height="48" className="w-12 h-12 rounded-xl object-cover shrink-0" loading="lazy" />)}
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
